import type { ReactNode } from 'react';
import { DataTable as BaseDataTable, type DataTableProps } from '@noor/ui';
import { TableEmptyState } from './table-empty-state';

/** Cpanel tables share one empty layout while retaining screen-specific copy. */
export function DataTable<TData>({
  emptyMessage = 'No results.',
  emptyDescription,
  ...props
}: DataTableProps<TData> & { emptyDescription?: ReactNode }) {
  return (
    <BaseDataTable
      {...props}
      emptyMessage={
        <TableEmptyState title={emptyMessage} description={emptyDescription} />
      }
    />
  );
}
